import React, { useEffect, useRef } from "react";
import { dsnCN } from "../../hooks/helper";
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faSpotify,
  faTiktok,
  faYoutube,
  faApple,
} from "@fortawesome/free-brands-svg-icons";
import { splittingItems } from "../../hooks/Spltting";

function SocialMedia({ className }) {
  const ref = useRef();
  const socialData = [
    {
      icon: faSpotify,
      link: "https://open.spotify.com/artist/7435s1bwxVh0coVrNSX7QD?si=x-OmYCFdQSCq_3WGoXlTOA",
    },
    {
      icon: faYoutube,
      link: "https://www.youtube.com/@mystirien?sub_confirmation=1",
    },
    {
      icon: faInstagram,
      link: "https://www.instagram.com/Mystirien",
    },
    {
      icon: faTiktok,
      link: "https://www.tiktok.com/@mystirien",
    },
    {
      icon: faApple,
      link: "https://music.apple.com/us/artist/mystirien/1864939108",
    },
  ];

  useEffect(() => {
    splittingItems(ref.current, "li");
  });

  return (
    <ul className={dsnCN("social-one", className)} ref={ref}>
      {socialData.map((item, index) => (
        <li key={index}>
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={item.icon} />
          </a>
        </li>
      ))}
    </ul>
  );
}

export default SocialMedia;
